
import React from 'react';
import WaitlistSection from '../components/WaitlistSection';

const AboutView: React.FC = () => {
  return (
    <div className="bg-background min-h-screen">
      <section className="max-w-[1400px] mx-auto border-x border-border p-12 lg:p-24 bg-white">
        <div className="max-w-4xl mx-auto text-center space-y-8">
          <span className="text-[10px] font-mono text-secondary uppercase tracking-[0.2em] mb-4 inline-block">Our Mission</span>
          <h2 className="text-5xl md:text-8xl font-display tracking-tight text-primary uppercase leading-[0.85]">
            The World is <br/>A Workshop.
          </h2>
          <p className="text-secondary text-xl font-normal leading-relaxed max-w-2xl mx-auto">
            We are building a distributed manufacturing network that puts production back in the hands of the people. No factories, no long-haul shipping, just community.
          </p>
        </div>
      </section>

      <section className="max-w-[1400px] mx-auto border-x border-border border-y bg-neutral-50 grid lg:grid-cols-2 divide-y lg:divide-y-0 lg:divide-x divide-border">
        <div className="p-12 lg:p-24 flex flex-col justify-center space-y-6">
          <h3 className="text-2xl font-display uppercase tracking-tight">The Problem</h3>
          <p className="text-secondary leading-relaxed">
            Traditional manufacturing relies on centralized factories thousands of miles away. This means massive carbon footprints from shipping, waste from overproduction, and high costs for the end user.
          </p>
        </div>
        <div className="p-12 lg:p-24 flex flex-col justify-center space-y-6">
          <h3 className="text-2xl font-display uppercase tracking-tight">The Zetra Vision</h3>
          <p className="text-secondary leading-relaxed">
            By turning idle local printers into nodes, we eliminate the need for global logistics. We want to see a world where you can click "Print" and have your object made by your neighbor, delivered in hours, not weeks.
          </p>
        </div>
      </section>

      <section className="max-w-[1400px] mx-auto border-x border-border p-12 lg:p-24 bg-white grid md:grid-cols-3 gap-12">
        {[
          { t: '90% Less CO2', d: 'By eliminating global shipping, Zetra reduces the environmental impact of physical goods.' },
          { t: 'Zero Waste', d: 'On-demand manufacturing means we only make exactly what is needed.' },
          { t: 'Local Wealth', d: 'Your money stays in your community, supporting local makers and entrepreneurs.' }
        ].map((item, idx) => (
          <div key={idx} className="space-y-4">
            <h4 className="text-xl font-display uppercase tracking-tight text-primary">{item.t}</h4>
            <p className="text-sm text-secondary leading-relaxed">{item.d}</p>
          </div>
        ))}
      </section>

      <section className="max-w-[1400px] mx-auto border-x border-border p-12 lg:p-24 bg-background text-center">
        <div className="max-w-2xl mx-auto space-y-8">
           <iconify-icon icon="lucide:heart" class="text-4xl text-primary animate-pulse"></iconify-icon>
           <h3 className="text-2xl font-display uppercase">Designed for humans</h3>
           <p className="text-secondary text-sm">Zetra isn't just a platform; it's a movement towards more intentional consumption and production. Thank you for being part of it.</p>
        </div>
      </section>
      <WaitlistSection />
    </div>
  );
};

export default AboutView;
